export enum WalletConnectTransactionError {
  WRONG_ACCOUNT = 'WRONG_ACCOUNT',
  WRONG_NETWORK = 'WRONG_NETWORK',
  UNSUPPORTED_METHOD = 'UNSUPPORTED_METHOD',
  NATIVE_SEND_UNSUPPORTED = 'NATIVE_SEND_UNSUPPORTED',
}

export type WalletConnectDappData = {
  name?: string;
  description?: string;
  imageUri?: string;
  dappUri?: string;
  topic: string;
};

export type WalletConnectTransactionData = {
  topic: string;
  to: string;
  data: string;
  value: string;
};

export type WalletConnectSessionRequestEvent = {
  id: number;
  topic: string;
};

export type UseWalletConnectResult = {
  dappData: WalletConnectDappData[];
  transactionData: WalletConnectTransactionData | null;
  transactionError: WalletConnectTransactionError | null;
  activeRequestTopic: string | null;
  isConnecting: boolean;
  connectToDapp: (uri: string) => Promise<void>;
  cancelPendingConnection: () => void;
  disconnect: (topic: string) => Promise<void>;
  approveTransactionRequest: () => Promise<void>;
  rejectTransactionRequest: () => Promise<void>;
  clearTransactionData: () => void;
};
